import { FontAwesomeIcon } from '@fortawesome/Vue-fontawesome'
import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {far} from '@fortawesome/free-regular-svg-icons'

import MainContainerCmp from '../components/main-container.vue'
import FormCmp from '../components/form/form.vue'
import FormItemCmp from '../components/form/form-item.vue'
import FieldCmp from '../components/form/field.vue'
import FieldInputCmp from '../components/form/field/input.vue'
import FieldInputTargetCmp from '../components/form/field/input-target.vue'
import FieldSelectCmp from '../components/form/field/select.vue'
import FieldRadioGroupCmp from '../components/form/field/radio-group.vue'
import FieldSwitchInputCmp from '../components/form/field/switch-input.vue'
import FieldTextAreaCmp from '../components/form/field/textarea.vue'
import FieldFileInputCmp from '../components/form/field/file-input.vue'
import FieldUploadDsCmp from '../components/form/field/upload-ds.vue'
import TooltipIconCmp from '../components/tooltip/tooltip-icon.vue'
import FixedHeaderTableCmp from '../components/table/fixed-header-table.vue'


export default function (SkyFoxVue) {

  library.add(fas, far)
  SkyFoxVue.component('font-awesome-icon', FontAwesomeIcon)

  SkyFoxVue.component('main-container', MainContainerCmp)
  SkyFoxVue.component('form-container', FormCmp)
  SkyFoxVue.component('form-item-container', FormItemCmp)
  SkyFoxVue.component('field-container', FieldCmp)
  SkyFoxVue.component('field-input', FieldInputCmp)
  SkyFoxVue.component('field-input-target', FieldInputTargetCmp)
  SkyFoxVue.component('field-select', FieldSelectCmp)
  SkyFoxVue.component('field-radio-group', FieldRadioGroupCmp)
  SkyFoxVue.component('field-switch-input', FieldSwitchInputCmp)
  SkyFoxVue.component('field-textarea', FieldTextAreaCmp)
  SkyFoxVue.component('field-file-input', FieldFileInputCmp)
  SkyFoxVue.component('field-upload-ds', FieldUploadDsCmp)
  SkyFoxVue.component('tooltip-icon', TooltipIconCmp)
  SkyFoxVue.component('fixed-header-table', FixedHeaderTableCmp)

  return SkyFoxVue
}



// WEBPACK FOOTER //
// ./src/extentions/components.js